import constants from '@/api';

const initialState = () => ({
	demo: false,
	requestModal: false,
	selectedRequest: {},
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		setSelectedRequest(state, req) {
			state.selectedRequest = JSON.parse(JSON.stringify(req));
		},
		openRequestModal(state) {
			state.requestModal = true;
		},
		closeRequestModal(state) {
			state.requestModal = false;
		},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getAPICall: ({ commit, dispatch }, { url, params }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: params,
					url: url,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || '');
				});
		},
		postAPICall: ({ commit, dispatch }, { url, data }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: data,
					url: url,
					config: { headers: { 'Content-Type': 'application/json' } },
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		putAPICall: ({ commit, dispatch }, { url, data }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'put',
					data: data,
					url: url,
					config: { headers: { 'Content-Type': 'application/json' } },
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
	},
	getters: {
		requestModal: state => state.requestModal,
		selectedRequest: state => state.selectedRequest,
	},
};
